import { useQuery } from '@tanstack/react-query';
import type { TSMSProviderTemplatePayload } from 'components/FlowBuilder/FlowSidePanels/types';
import smsService from 'services/api/sms.api';

const useSMSTemplate = (templateId: string) => {
  const {
    data: smsTemplate,
    error: smsTemplateError,
    isFetching: isSMSTemplateFetching,
    refetch: refetchSMSTemplate,
  } = useQuery<TSMSProviderTemplatePayload, Error>({
    queryKey: ['sms-template', templateId],
    queryFn: () => smsService.getSMSTemplate(templateId),
    enabled: !!templateId,
  });

  return { smsTemplate, smsTemplateError, isSMSTemplateFetching, refetchSMSTemplate };
};

export default useSMSTemplate;
